export const STATUS = {
  offen: { label: "Offen", dot: "#EF4444", bg: "bg-red-50", text: "text-red-700", border: "border-red-200" },
  in_bearbeitung: { label: "In Bearbeitung", dot: "#F59E0B", bg: "bg-amber-50", text: "text-amber-700", border: "border-amber-200" },
  wartet_rueckmeldung: { label: "Wartet auf Rückmeldung", dot: "#8B5CF6", bg: "bg-violet-50", text: "text-violet-700", border: "border-violet-200" },
  behoben: { label: "Behoben", dot: "#10B981", bg: "bg-emerald-50", text: "text-emerald-700", border: "border-emerald-200" },
  erledigt: { label: "Erledigt", dot: "#22C55E", bg: "bg-green-50", text: "text-green-700", border: "border-green-200" },
  abgenommen: { label: "Abgenommen", dot: "#0D9488", bg: "bg-teal-50", text: "text-teal-700", border: "border-teal-200" },
  geschlossen: { label: "Geschlossen", dot: "#64748B", bg: "bg-slate-100", text: "text-slate-600", border: "border-slate-200" },
};

export const STATUS_OPTIONS = [
  { value: "offen", label: "Offen" },
  { value: "in_bearbeitung", label: "In Bearbeitung" },
  { value: "erledigt", label: "Erledigt" },
];

export const TICKET_STATUS_OPTIONS = [
  { value: "offen", label: "Offen" },
  { value: "in_bearbeitung", label: "In Bearbeitung" },
  { value: "wartet_rueckmeldung", label: "Wartet auf Rückmeldung" },
  { value: "erledigt", label: "Erledigt" },
  { value: "abgenommen", label: "Abgenommen" },
  { value: "geschlossen", label: "Geschlossen" },
];

export const DEFECT_STATUS_OPTIONS = [
  { value: "offen", label: "Offen" },
  { value: "in_bearbeitung", label: "In Bearbeitung" },
  { value: "behoben", label: "Behoben" },
  { value: "abgenommen", label: "Abgenommen" },
  { value: "geschlossen", label: "Geschlossen" },
];

export const TICKET_CATEGORIES = [
  { value: "mangel", label: "Mangel" },
  { value: "aufgabe", label: "Aufgabe" },
  { value: "pruefung", label: "Prüfung" },
  { value: "freigabe", label: "Freigabe" },
  { value: "material", label: "Material" },
  { value: "montage", label: "Montage" },
  { value: "planung", label: "Planung" },
  { value: "sonstiges", label: "Sonstiges" },
];

export const PRIORITIES = [
  { value: "niedrig", label: "Niedrig" },
  { value: "normal", label: "Normal" },
  { value: "hoch", label: "Hoch" },
  { value: "kritisch", label: "Kritisch" },
];

export const GEWERKE = [
  "Rohbau", "Trockenbau", "Elektro", "Sanitär/Heizung", "Fliesenleger", "Maler",
  "Estrich", "Zimmerer/Dach", "Fenster/Türen", "Fassade", "Bodenbelag", "Außenanlagen", "Sonstiges",
];

export const PROJECT_STATUS = [
  { value: "planung", label: "Planung" },
  { value: "aktiv", label: "Aktiv" },
  { value: "pausiert", label: "Pausiert" },
  { value: "abgeschlossen", label: "Abgeschlossen" },
  { value: "archiviert", label: "Archiviert" },
];

export const PROJECT_STATUS_STYLE = {
  planung: "bg-sky-50 text-sky-700 border-sky-200",
  aktiv: "bg-green-50 text-green-700 border-green-200",
  pausiert: "bg-amber-50 text-amber-700 border-amber-200",
  abgeschlossen: "bg-slate-100 text-slate-700 border-slate-200",
  archiviert: "bg-slate-100 text-slate-500 border-slate-200",
};

export const UNITS = ["Stück", "m", "m²", "m³", "kg", "t", "Liter", "Stunden"];

export const MATERIALS = ["Beton", "Stahl", "Mauerwerk", "Estrich", "Trockenbau", "Fliesen", "Bodenbelag", "Türen", "Fenster", "Leitungen", "Kabel", "Rohrleitungen", "Sonstiges"];

export const WEATHER = ["Sonnig", "Heiter", "Bewölkt", "Regen", "Starkregen", "Schnee", "Frost", "Wind/Sturm", "Nebel"];

export const PHASES = [
  { value: "", label: "Ohne Kennzeichnung" },
  { value: "vorher", label: "Vorher" },
  { value: "nachher", label: "Nachher" },
];

export const LINK_TYPES = [
  { value: "project", label: "Projekt" }, { value: "building", label: "Gebäude" }, { value: "floor", label: "Geschoss" },
  { value: "plan", label: "Bauplan" }, { value: "position", label: "Position" }, { value: "ticket", label: "Ticket" }, { value: "defect", label: "Mangel" },
];

export const MARKER_TOOLS = [
  { value: "point", label: "Punkt", color: "#EF4444", icon: "MapPin" },
  { value: "rectangle", label: "Rechteck", color: "#2563EB", icon: "Square" },
  { value: "polygon", label: "Polygon", color: "#7C3AED", icon: "Hexagon" },
  { value: "freehand", label: "Freihand", color: "#EC4899", icon: "Pencil" },
  { value: "line", label: "Linie", color: "#059669", icon: "Minus" },
  { value: "area", label: "Bereich", color: "#D97706", icon: "LassoSelect" },
];

export const labelStatus = (s) => (STATUS[s] ? STATUS[s].label : s);
